import { Loader } from "@googlemaps/js-api-loader";

export class GoogleMapsLoader {
    private static _loader: Loader | null = null;

    static getLoader(apiKey: string): Loader {
        // The Maps script loads once per page with the first key it sees, so a keyless loader
        // would lock out every later caller that does have one.
        if (!apiKey)
            throw new Error("A Google Maps API key is required to load the Maps script.");

        this._loader ??= new Loader({
            apiKey,
            version: "quarterly" // same intent as your script tag
            // do NOT pass libraries here if you plan to use importLibrary()
        });
        return this._loader;
    }
}